
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import { pause, resume, cancel } from '../chunkUpload';
import {
    uploadPause,
    uploadResume,
    uploadCancel,
} from '../../../../../actions/upload';

import ProgressBar from '../../../../../components/ProgressBar';
import IconPlay from '../../../../../icons/play.svg';
import IconPause from '../../../../../icons/pause.svg';
import IconCancel from '../../../../../icons/cancel2.svg';
import ReactSVG from 'react-svg'
import DefaultButton from '../../../../../components/DefaultButton';

const UploadProgressBarWrapper = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: row;  
  justify-content: flex-start;
  align-items: center;  

  border: 1px solid #ebebeb;
  border-radius: 5px;
  background-color: #ffffff;
  width: calc(100% - 20px);
  padding: 5px 10px;
  margin-bottom: 10px;
`;

class UploadProgressBar extends React.Component<Props, State> {
    constructor(props){
        super();
    }

    render() {
        const { t, uploadProgress, uploadLoading, visible,
            uploadPause, uploadCancel, uploadResume, simpleUpload, uploadMessage } = this.props;
            
        let uploadMessageText = uploadMessage ? t(uploadMessage.text) : "";
        if (uploadMessage && uploadMessage.filesCount > 1 && uploadMessage.result === 'success') {
            uploadMessageText = t('upload_finished_many').replace("{amount}", uploadMessage.filesCount);
        }

        return (
            <UploadProgressBarWrapper visible={visible}>
                <ProgressBar
                    label={uploadMessageText}
                    visible={true}
                    progress={uploadProgress}
                    fail={uploadMessage.result === 'fail'}
                />
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                        display: !simpleUpload && uploadLoading ? 'flex' : 'none'
                    }}
                    title={t('Pause')}
                    onClick={() => {
                        pause();
                        uploadPause();
                    }}>
                    <ReactSVG
                        path={IconPause}
                        style={{
                            fill: '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                        display: !simpleUpload && (uploadMessage.result === 'pause' 
                            || uploadMessage.result === 'fail') ? 'flex' : 'none'
                    }}
                    title={t('Resume')}
                    onClick={() => {
                        resume();
                        uploadResume();
                    }}>
                    <ReactSVG
                        path={IconPlay}
                        style={{
                            fill: '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
                <DefaultButton
                    style={{
                        margin: '2px',
                        flexShrink: 0,
                        display: !simpleUpload && (uploadMessage.result === 'pause' 
                            || uploadMessage.result === 'progress'
                            || uploadMessage.result === 'fail'
                            || uploadMessage.result === 'resume') ? 'flex' : 'none'                            
                    }}
                    title={t('Cancel')}
                    onClick={() => {
                        cancel();
                        uploadCancel();
                    }}>
                    <ReactSVG
                        path={IconCancel}
                        style={{
                            fill: '#dddddd',
                            padding: '5px',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </DefaultButton>
            </UploadProgressBarWrapper>
        );
    }
}

const mapStateToProps = state => ({
    uploadProgress: state.upload.get('uploadProgress'),
    uploadLoading: state.upload.get('uploadLoading'),
    uploadMessage: state.upload.get('uploadMessage'),
    uploadFileName: state.upload.get('uploadFileName'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    uploadPause,
    uploadResume,
    uploadCancel
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(UploadProgressBar));


// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/uploadProgressBar/UploadProgressBar.jsx